import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'da-booking-error',
    templateUrl: './booking-error.component.html',
    styleUrls: ['./booking-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BookingErrorComponent implements OnInit {
    constructor(private _route: ActivatedRoute, private _router: Router) {}

    ngOnInit(): void {
        window.scrollTo(0, 0);
        if (this._route.snapshot.url[0] && this._route.snapshot.url[0].path.toLowerCase() !== this._route.snapshot.url[0].path) {
            this._router.navigate([this._route.snapshot.url[0].path.toLowerCase()]);
        }
    }
}
